import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';

const AISettings = new Mongo.Collection('AISettings');

AISettings.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

AISettings.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});
const AISettingsSchema = new SimpleSchema({
  Resolution: {
    type: Number,
    label: 'Nivel de resolución',
    defaultValue: 0.25
  },
  LimitSueface: {
    type: Number,
    label: 'Limite de Superficie',
    defaultValue: 100
  },
  LayerName: {
    type: String,
    label: 'Layer Name'
  },
  ServiceType: {
    type: String,
    label: 'Service Type'
  },
  URL: {
    type: String,
    label: 'What is the URL?'
  },
  value: {
    type: SimpleSchema.oneOf(Boolean, Number, String),
    label: 'The value for the setting',
    autoValue() {
      // eslint-disable-line
      // NOTE: Pass default value as a string to get around this:
      // https://github.com/aldeed/simple-schema-js/issues/169
      const type = this.field('type');
      if (type.value) {
        return {
          boolean: this.value == 'true', // eslint-disable-line
          string: this.value,
          number: parseInt(this.value, 10)
        }[type.value];
      }
      return undefined;
    },
    optional: true
  },
  BatchSize: {
    type: Number,
    label: 'Batch Size',
    defaultValue: 32
  },
  StepPerEpoch: {
    type: Number,
    label: 'Step por Epoch',
    defaultValue: 20
  },
  ValidationStep: {
    type: Number,
    label: 'Validation Step',
    defaultValue: 100
  }
});

AISettings.attachSchema(AISettingsSchema);

export default AISettings;
